import type { PlanInfo, PlanTier, Quota } from '../api/planApi';

export interface TokenBalance {
  /** Сколько жетонов осталось на сегодня. */
  left: number;
  /** Дневной набор тарифа. */
  limit: number;
  /** Доля остатка 0–1: полоса баланса в полночь полная и пустеет с каждой тратой. */
  share: number;
  /** Мало осталось — пятая часть набора или меньше. */
  low: boolean;
  /** Жетоны на сегодня закончились. */
  out: boolean;
  /** Несгораемые жетоны — тратятся, когда дневные закончились. */
  bonus: number;
  /** Можно потратить сейчас: дневные плюс несгораемые. */
  spendable: number;
}

/**
 * Остаток жетонов на сегодня — «баланс» (решение владельца 2026-10-13: показываем,
 * сколько осталось, а не сколько потрачено; полоса работает на уменьшение).
 * Одна формула для боковой панели, композера, главной и тарифов.
 */
const NEXT_TIER: Partial<Record<PlanTier, PlanTier>> = { DEMO: 'PRO', PRO: 'PREMIUM' };

/** Следующий тариф из `/plans`: подписи про тариф берут название и лимит отсюда, а не из текста. У Max следующего нет. */
export function nextPlan(plans: PlanInfo[] | undefined, tier: PlanTier): PlanInfo | null {
  return plans?.find((p) => p.tier === NEXT_TIER[tier]) ?? null;
}

export function tokenBalance(quota: Pick<Quota, 'dailyLimit' | 'remaining'> & Partial<Pick<Quota, 'bonus'>>): TokenBalance {
  const limit = Math.max(0, quota.dailyLimit);
  const left = Math.max(0, Math.min(limit, quota.remaining));
  const share = limit > 0 ? left / limit : 0;
  const bonus = Math.max(0, quota.bonus ?? 0);
  return { left, limit, share, out: left <= 0, low: left > 0 && share <= 0.2, bonus, spendable: left + bonus };
}
